'use client';

import { Content, isFilled } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import styles from './hubspot-form.module.scss';
import { useEffect } from 'react';

type Hubspot = typeof window & {
    hbspt: {
        forms: {
            create: (options: {
                target: string;
                region: string;
                portalId: string;
                formId: string;
            }) => void;
        };
    };
};

const HUBSPOT_PORTAL_IDS = {
    sandbox: '49526387',
    production: '2624959',
};

export type HubspotFormProps = SliceComponentProps<Content.HubspotFormSlice>;

const HubspotForm = ({ slice }: HubspotFormProps): JSX.Element => {
    useEffect(() => {
        const scriptTag = document.createElement('script');

        scriptTag.src = 'https://js.hsforms.net/forms/v2.js';
        scriptTag.onload = () => {
            if (isFilled.keyText(slice.primary.form_id)) {
                (window as Hubspot).hbspt.forms.create({
                    target: '#hubspot-form',
                    region: 'na1',
                    portalId:
                        slice.primary.hubspot_env === 'sandbox'
                            ? HUBSPOT_PORTAL_IDS.sandbox
                            : HUBSPOT_PORTAL_IDS.production,
                    formId: slice.primary.form_id as string,
                });
            }
        };

        document.body.appendChild(scriptTag);

        return () => {
            document.body.removeChild(scriptTag);
        };
    }, [slice.primary.form_id, slice.primary.hubspot_env]);

    return <section id="hubspot-form" className={styles['wrapper']} />;
};

export default HubspotForm;
